import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from '@/locales/en.json';
import cn_zh from '@/locales/cn-zh.json';
import cn_tw from '@/locales/cn-tw.json';

Vue.use(VueI18n)

var clientConfig = localStorage['locale'];
var locale = 'en';

if (clientConfig != undefined) 
{
  locale = clientConfig;
  document.cookie = `locale=${clientConfig};path=/`;
}
else 
{
  // set server side locale follow frontend default
  document.cookie = `locale=${locale};path=/`;
}

const loadedLanguages = {
  en: en,
  cn_zh: cn_zh,
  cn_tw: cn_tw
}

const messages = {}
messages[locale] = loadedLanguages[locale]

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en',
  messages
})

export default i18n
